<app-login *ngIf="!hospitalURL && !schoolURL && !societyURL && !crmURL"></app-login>

<app-hospital-login *ngIf="hospitalURL"></app-hospital-login>

<app-school-login *ngIf="schoolURL"></app-school-login>

<app-society-login *ngIf="societyURL"></app-society-login>

<app-crm-login *ngIf="crmURL"></app-crm-login>